import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  DialogFooter,
  DialogClose,
} from '@/components/ui/dialog';
import { useDeleteCollectionOrder } from '@/hooks/collectionOrder/useDeleteCollectionOrder';
import toast from 'react-hot-toast';
import { useState } from 'react';
import Spinner from '@/components/Spinner';

interface DeleteProps {
  collectionId: string | undefined;
  onDelete: () => void;
}

const Delete: React.FC<DeleteProps> = ({ collectionId, onDelete }) => {
  const { loading, error, deleteCollectionOrder } = useDeleteCollectionOrder();
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDeleteCompany = async () => {
    if (!collectionId) {
      toast.error('Collection does not exist');
      return;
    }

    setIsDeleting(true);
    try {
      await deleteCollectionOrder(collectionId);
      onDelete();
      toast.success('Collection deleted successfully');
    } catch (err) {
      console.error('Error deleting Collection', err);
      toast.error('Failed to delete the collection. Please try again.');
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <Dialog>
      <DialogTrigger className='h-7 w-7 border flex justify-center items-center border-[#FF0000]/90 rounded-lg hover:bg-[#FF0000]/10 transition ease-in-out duration-200'>
        <img
          className='h-[17px] w-[17px]'
          src='/assets/icons/trash.svg'
          alt='delete'
        />
      </DialogTrigger>
      <DialogContent className='md:w-[25%] w-[90%] px-8 bg-white'>
        <DialogHeader>
          <DialogTitle className='font-medium text-base md:text-lg'>
            Are you sure you want to delete this Collection?
          </DialogTitle>

          <DialogFooter className='flex flex-row w-full justify-center space-x-4'>
            <DialogClose className='mt-4' asChild>
              <Button
                className='rounded-[5px] w-1/2 border-[#FF0000] bg-[#FF0000]/10 text-[#FF0000] hover:bg-[#FF0000]/20'
                variant='outline'
                type='button'
              >
                No
              </Button>
            </DialogClose>
            <Button
              className='rounded-[5px] mt-4 w-1/2 border-[#FF0000] bg-[#FF0000] text-white hover:bg-[#FF0000]/90'
              type='button'
              onClick={handleDeleteCompany}
              disabled={loading || isDeleting} // Disable button while loading
            >
              {isDeleting ? <Spinner /> : 'Yes'}
            </Button>
          </DialogFooter>
        </DialogHeader>
      </DialogContent>

      {error && <div className='mt-2 text-red-500 text-center'>{error}</div>}
    </Dialog>
  );
};

export default Delete;
